import { PageLoader } from "@asurion-core/mx-asurion-ui-react";
import { ContentfulProvider, PortalThemeBoundary, GlobalStyles as Styles } from "@ubif/components";
import { AbilityProvider, getVersionInfo, store } from "@ubif/util-store";
import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { MainLayout } from "./MainLayout";

console.log("App Version Info", getVersionInfo());

export default function Root() {
  return (
    <React.StrictMode>
      <Styles />
      <BrowserRouter>
        <ContentfulProvider>
          <Provider store={store}>
            <Suspense fallback={<PageLoader />}>
              <AbilityProvider>
                <PortalThemeBoundary>
                  <MainLayout />
                </PortalThemeBoundary>
              </AbilityProvider>
            </Suspense>
          </Provider>
        </ContentfulProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}
